import { render, staticRenderFns } from "./DeletePublisherDialog.vue?vue&type=template&id=90ba458a&scoped=true"
import script from "./DeletePublisherDialog.vue?vue&type=script&lang=js"
export * from "./DeletePublisherDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ba458a",
  null
  
)

export default component.exports